import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { reduxForm, reset } from 'redux-form';
import Joi from 'joi-full';
import { getShop } from '../../../auth/selectors';
import { trimData } from '../../../common/trimData';
import withNotifications from '../../../common/withNotifications';
import { addCustomGiftCard, fetchGiftCardSummary } from '../actions';
import withToggle from '../../../common/hoc/withToggle';
import { syncValidateData } from '../../../common/validator';
import AddGiftCard from '../components/AddGiftCard';
import { ADD_CARD_FORM } from '../constants';

const schema = Joi.object().keys({
  initialBalance: Joi.number()
    .min(1)
    .required(),
  code: Joi.string()
    .min(6)
    .optional()
    .required(),
});

const validate = values => syncValidateData(values, schema);

const form = reduxForm({
  form: ADD_CARD_FORM,
  validate,
});

const AddGiftCardContainer = compose(
  connect(
    state => ({
      shopId: getShop(state),
    }),
    { resetForm: reset, addCustomGiftCard, fetchGiftCardSummary }
  ),
  withToggle(),
  withNotifications,
  withHandlers({
    onSubmit: props => data =>
      props.addCustomGiftCard(props.shopId, trimData(data)).then(() => {
        props.off();
        props.fetchGiftCardSummary(props.shopId);
        props.addNotification({
          title: 'Success',
          level: 'success',
          message: 'Card added successfully!',
        });
        props.resetForm(ADD_CARD_FORM);
      }),
  }),
  form,
)(AddGiftCard);

export default AddGiftCardContainer;
